import InfoAlert from 'lib/ui/alerts/InfoAlert'
import {UserRegistrationMode} from 'organization/Event/Services/Apps/Obie'
import React from 'react'

export interface ModeDescriptionProps {
  mode: UserRegistrationMode
}

export default function ModeDescription(props: ModeDescriptionProps) {
  const {mode} = props

  if (mode === 'disabled') {
    return (
      <InfoAlert>
        Obvio will log in attendees, but only existing OBIE Users will be logged
        in. Others will land on the login page.
      </InfoAlert>
    )
  }

  if (mode === 'sign_up') {
    return (
      <InfoAlert>
        Attendees are redirected to the selected Offer below with their details
        pre-filled.
      </InfoAlert>
    )
  }

  return (
    <InfoAlert>
      Obvio automatically registers each attendee and logs them into the
      selected AI Hub.
    </InfoAlert>
  )
}
